import { useSelector } from "react-redux";
import { LOGO_FULL, LOGO_ICON, LOGO_ROUNDED } from "../utils/image.constants";

/**
 * useCompanyLogo
 *
 * Fetches the dynamic company logo from the Redux user state.
 * Gracefully falls back to the static default logos if the user is
 * not authenticated or their company doesn't have a logo uploaded.
 *
 * @returns {{ fullLogo: string, iconLogo: string, roundedLogo: string }}
 */
export const useCompanyLogo = () => {
  const userDetails = useSelector((state) => state.user?.user);

  const companyLogoUrl = userDetails?.company?.logoFile?.url;
  const companyThumbnailUrl = userDetails?.company?.logoFile?.thumbnailUrl;

  return {
    fullLogo: companyLogoUrl || LOGO_FULL,
    iconLogo: companyThumbnailUrl || LOGO_ICON,
    roundedLogo: companyThumbnailUrl || LOGO_ROUNDED,
  };
};
